import { trimEndSlash } from "~/utils/urlUtils";

export const ensureLastSlash = (str: string) => `${trimEndSlash(str)}/`;
